import { useState, useEffect, useContext } from 'react';
import styled from 'styled-components';
import { HeaderAtom } from '../../atoms/atomSample';
import { useNavigate, Link } from "react-router-dom";
import { useRecoilState } from 'recoil';
import modeling from '../../resource/modeling.jpg';
import coding from '../../resource/coding.png';
import substance from '../../resource/substance.png';
import ZBrush from '../../resource/zcar.png';
import python from '../../resource/python.jpeg';
import javascript from '../../resource/javascript.jpg';
import { AuthContext, useAuth } from "../../authContext";
import { CartAtom } from '../../atoms/accountAtom';
import { reqGet, reqPost } from '../../service';

const Container = styled.div`
 max-width: 1200px;
 margin: 0 auto;
 padding: 20px;
 display: flex;
 gap: 24px;
`;

const MainContent = styled.div`
 flex: 1;
`;

const Grid = styled.div`
 display: grid;
 grid-template-columns: repeat(4, 1fr);
 gap: 24px;

 @media (max-width: 1200px) {
   grid-template-columns: repeat(3, 1fr);
 }

 @media (max-width: 900px) {
   grid-template-columns: repeat(2, 1fr);
 }

 @media (max-width: 600px) {
   grid-template-columns: repeat(1, 1fr);
 }
`;

const Card = styled.div`
 background: white;
 border-radius: 8px;
 overflow: hidden;
 box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
`;

const CardImage = styled.div`
 width: 100%;
 height: 200px;
 background: #f1f1f1;
 display: flex;
 align-items: center;
 justify-content: center;
`;

const CardContent = styled.div`
 padding: 16px;
`;

const Title = styled.h3`
 font-size: 16px;
 margin: 0 0 8px 0;
 color: #111827;
`;

const Price = styled.p`
 font-size: 14px;
 margin: 0 0 16px 0;
 color: #111827;
`;

const ButtonGroup = styled.div`
 display: flex;
 gap: 8px;
`;

const Button = styled.button`
 flex: 1;
 padding: 8px 16px;
 border-radius: 4px;
 border: none;
 font-size: 14px;
 cursor: pointer;
 
 ${props => props.primary ? `
   background: #111827;
   color: white;
 ` : `
   background: #f3f4f6;
   color: #111827;
 `}
`;

const Sidebar = styled.div`
 width: 300px;
`;

const SidebarCard = styled.div`
 background: white;
 border-radius: 8px;
 padding: 16px;
 box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
 margin-bottom: 16px;
`;

const SidebarTitle = styled.h2`
 font-size: 16px;
 margin: 0 0 16px 0;
 color: #111827;
`;

const CheckoutButton = styled(Button)`
 width: 100%;
 background: #111827;
 color: white;
`;

const CartItemContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid #f3f4f6;

  &:last-child {
    border-bottom: none;
  }
`;

const CartQuantity = styled.div`
 display: flex;
 align-items: center;
 gap: 8px;
`;

const DeleteButton = styled.button`
 background: none;
 border: none;
 color: #ef4444;
 cursor: pointer;
 padding: 4px;
 font-size: 14px;
`;

const TabContainer = styled.div`
 display: flex;
 gap: 10px;
 margin-bottom: 20px;
`;

const Tab = styled.button`
 padding: 8px 16px;
 border-radius: 20px;
 border: none;
 background: ${props => props.active ? '#00ADB5' : '#f5f5f5'};
 color: ${props => props.active ? 'white' : '#333'};
 cursor: pointer;
 font-weight: 500;
`;

const CourseCard = ({ title, price, prodImg, AddItem, CartList }) => {
   const navigate = useNavigate();
   
   const purchase = (item) => {
       var ItemListArray = [item];
       AddItem(ItemListArray);
       navigate('/Product', { state: [item] });
   }

   const cart = (newItem) => {
       const numericPrice = parseInt(newItem.price);
       let itemFound = false;
       const updatedCart = CartList.map((item) => {
           if (item.title === newItem.title) {
               itemFound = true;
               return {
                   ...item,
                   price: numericPrice,
                   quantity: item.quantity ? item.quantity + 1 : 2
               };
           }
           return item;
       });

       if (!itemFound) {
           AddItem([...CartList, { ...newItem, price: numericPrice, quantity: 1 }]);
       } else {
           AddItem(updatedCart);
       }
   };

   return (
       <Card>
           <CardImage>
               <img src={prodImg} alt={title} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
           </CardImage>
           <CardContent>
               <Title>{title}</Title>
               <Price>가격: {price}원</Price>
               <ButtonGroup>
                   <Button onClick={() => cart({ title: title, price: price })}>장바구니</Button>
                   <Button primary onClick={() => purchase({ title: title, price: price })}>구매하기</Button>
               </ButtonGroup>
           </CardContent>
       </Card>
   );
};

export default function Store() {
   const [CartItem, setCartItem] = useRecoilState(CartAtom);
   const [dynamicItem, setDynamicItem] = useState([{title: ''}]);
   const [activeTab, setActiveTab] = useState('Coding');
   const [hoverItemIndex, setHoverItemIndex] = useState(-1);
   const { login, user } = useAuth();
   const navigate = useNavigate();

   useEffect(() => {
       reqPost('api/getProduct_List', { type: activeTab }, (result, objectParams) => setDynamicItem(result));
   }, [activeTab]);

   const updateQuantity = (itemToUpdate, delta) => {
       const updatedCart = CartItem.map((item) => {
           if (item.title === itemToUpdate.title) {
               const updatedQuantity = item.quantity + delta;
               return { ...item, quantity: updatedQuantity > 0 ? updatedQuantity : 1 };
           }
           return item;
       });
       setCartItem(updatedCart);
   };

   const getTotalPrice = () => {
       return CartItem.reduce((total, item) => total + item.price * (item.quantity || 1), 0);
   };

   const deleteItem = (itemToDelete) => {
       const updatedCart = CartItem.filter(item => item.title !== itemToDelete.title);
       setCartItem(updatedCart);
   };

   return (
       <Container>
           <MainContent>
               <TabContainer>
                   <Tab active={activeTab === 'Coding'} onClick={() => setActiveTab('Coding')}>Cloud</Tab>
                   <Tab active={activeTab === 'Graphics'} onClick={() => setActiveTab('Graphics')}>On-premise</Tab>
                   <Tab active={activeTab === 'DataBase'} onClick={() => setActiveTab('DataBase')}>Network</Tab>
               </TabContainer>

               {activeTab === 'Coding' && (
                   <Grid>
                       <CourseCard title="C# 입문" price={50000} prodImg={coding} AddItem={setCartItem} CartList={CartItem} />
                       <CourseCard title="Java 심화" price={10000} prodImg={javascript} AddItem={setCartItem} CartList={CartItem} />
                       <CourseCard title="Python 기초" price={10000} prodImg={python} AddItem={setCartItem} CartList={CartItem} />
                       <CourseCard title="JavaScript" price={10000} prodImg={javascript} AddItem={setCartItem} CartList={CartItem} />
                       {dynamicItem.map((item, idx) => (
                           <CourseCard 
                               key={idx}
                               title={item.prod_name} 
                               price={item.prod_price}
                               AddItem={setCartItem} 
                               CartList={CartItem} 
                           />
                       ))}
                   </Grid>
               )}

               {activeTab === 'Graphics' && (
                   <Grid>
                       <CourseCard title="3D-Max 입문 강의" price={10000} prodImg={modeling} AddItem={setCartItem} CartList={CartItem} />
                       <CourseCard title="Blender 입문 강의" price={10000} prodImg={modeling} AddItem={setCartItem} CartList={CartItem} />
                       <CourseCard title="ZBrush 입문 강의" price={10000} prodImg={ZBrush} AddItem={setCartItem} CartList={CartItem} />
                       <CourseCard title="SubstancePainter" price={10000} prodImg={substance} AddItem={setCartItem} CartList={CartItem} />
                       {dynamicItem.map((item, idx) => (
                           <CourseCard 
                               key={idx}
                               title={item.prod_name} 
                               price={item.prod_price}
                               AddItem={setCartItem} 
                               CartList={CartItem} 
                           />
                       ))}
                   </Grid>
               )}

               {/* 다른 탭들에 대한 비슷한 구현 */}
           </MainContent>
           
           <Sidebar>
               <SidebarCard>
                   <SidebarTitle>내 상품 리스트</SidebarTitle>
                   <div>장바구니</div>
                   <div style={{height:'auto'}} className="item-container">
                   {CartItem.map((item, idx) => (
        <CartItemContainer
            key={idx}
            onMouseEnter={() => setHoverItemIndex(idx)}
            onMouseLeave={() => setHoverItemIndex(-1)}
        >
            <span>{item.title}</span>
            <CartQuantity>
                <button onClick={() => updateQuantity(item, -1)}>-</button>
                {item.quantity || 1}
                <button onClick={() => updateQuantity(item, 1)}>+</button>
            </CartQuantity>
            <span>{item.price * (item.quantity || 1)}원</span>
            {hoverItemIndex === idx && (
                <DeleteButton onClick={() => deleteItem(item)}>X</DeleteButton>
            )}
        </CartItemContainer>
    ))}
                   </div>
                   <div style={{marginBottom: '12px'}}>
                       Total: {getTotalPrice()}원
                   </div>
                   <CheckoutButton onClick={() => navigate('/Product', {state: CartItem})}>
                       결제하기
                   </CheckoutButton>
               </SidebarCard>

               {user && (
                   <SidebarCard>
                       <SidebarTitle>앤츠코인 충전하기</SidebarTitle>
                       <div className="flex justify-between items-center mb-4">
                           <span className="text-gray-700">앤츠코인</span>
                           <span>0 원</span>
                       </div>
                       <div className="mb-4">
                           <label htmlFor="amount">금액입력</label>
                           <input 
                               type="text" 
                               id="amount"
                               placeholder="금액을 입력하세요"
                               className="w-full px-3 py-2 border rounded"
                           />
                       </div>
                       <CheckoutButton>충전하기</CheckoutButton>
                   </SidebarCard>
               )}
           </Sidebar>
       </Container>
   );
}